// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.AlertDetails.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { observable, computed, action } from 'mobx';
import { ALERT_TYPES, SHOW_TYPES } from 'logic/data/Izenda.AlertConstants';

export default class AlertDetails {
  @observable type: string = null;
  @observable message: string = null;
  @observable success: boolean = true;
  @observable errors: Array<Object> = [];
  @observable key: string = null;
  @observable showType: string = SHOW_TYPES.BRIEF;

  @computed
  get alertType() {
    let type;
    switch (this.success) {
      case true:
        type = ALERT_TYPES.SUCCESS;
        break;
      case false:
        type = ALERT_TYPES.ERROR;
        break;
      default:
        type = ALERT_TYPES.INFO;
        break;
    }
    return this.type || type;
  }

  constructor(data: Object = {}) {
    data && this.set(data);
  }

  /**
   * Set alert details
   * @param {Object} data
   */
  @action
  set(data: Object = {}) {
    data = data || {};
    this.success = data.success;
    this.message = data.message;
    this.errors = data.errors;
    this.key = data.key;
    this.showType = data.showType;
    this.type = data.type;
  }

  /**
   * Reset alert details
   * @param {boolean} resetSavedMessage Indicate reset saved message
   */
  @action
  reset(resetSavedMessage = true) {
    this.set({
      message: null,
      success: true,
      errors: [],
      key: null,
      showType: resetSavedMessage ? SHOW_TYPES.RESET : SHOW_TYPES.BRIEF,
      type: null
    });
  }
}



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.AlertDetails.js